import { getRoleDisplayName } from '@/globals/typescript/utils/roleUtils'
import { LabManagementUser as _LabManagementUser } from '@team-milva/lab-models/user'

export class LabManagementUser extends _LabManagementUser {
  constructor(params: Partial<_LabManagementUser> = {}) {
    super(params)
  }

  get mainRoleDisplayName(): string {
    return getRoleDisplayName(this.mainRole)
  }
}

